import { getEnemyDef } from "../game/constants/enemies";
import { TOWER_DEFS, TOWER_ORDER } from "../game/constants/towers";
import { Button } from "./Button";
import { TowerSpriteBadge, EnemySpriteBadge } from "./SpriteBadge";

export function TowerDock({ ui, currentMap, actions, selectedDef, limits }) {
	const nextWave = !ui.waveActive ? ui.nextWavePreview || [] : [];
	const campaignComplete = ui.runMode === "campaign" && ui.wave >= limits.wavesPerMap;

	return (
		<section className="tower-dock">
			<div className="tower-dock__cards">
				{TOWER_ORDER.map((type) => {
					const def = TOWER_DEFS[type];
					const selected = ui.selectedTower === type;
					return (
						<button key={type} className={`tower-card ${selected ? "is-selected" : ""}`} style={{ "--tone": def.color }} onClick={() => actions.selectTower(type)}>
							<TowerSpriteBadge type={type} />
							<div className="tower-card__topline">
								<strong>{def.name}</strong>
								<span className="tower-card__cost">{def.costs[0]}g</span>
							</div>
							<small>{def.desc}</small>
							<span className="tower-card__stats">DMG {def.damage[0]} | RNG {def.range[0]}</span>
						</button>
					);
				})}
			</div>
			<div className="dock-info">
				{ui.selectedPlaced && selectedDef ? (
					<div className="selected-tower" style={{ "--tone": selectedDef.color }}>
						<div>
							<div className="eyebrow">Selected Tower</div>
							<h3>{selectedDef.name} Lv.{ui.selectedPlaced.level + 1}</h3>
							<p>Damage {selectedDef.damage[ui.selectedPlaced.level]} - Range {selectedDef.range[ui.selectedPlaced.level]} - Rate {selectedDef.rate[ui.selectedPlaced.level]}ms</p>
						</div>
						<div className="selected-tower__actions">
							{ui.selectedPlaced.level < 3 && (
								<Button onClick={actions.upgradeTower} disabled={ui.gold < selectedDef.costs[ui.selectedPlaced.level + 1]}>
									Upgrade {selectedDef.costs[ui.selectedPlaced.level + 1]}
								</Button>
							)}
							<Button tone="danger" onClick={actions.sellTower}>Sell</Button>
							<Button tone="ghost" onClick={actions.clearSelection}>Close</Button>
						</div>
					</div>
				) : (
					<div className="wave-console">
						<div>
							<div className="eyebrow">Next Contact</div>
							<h3>{ui.waveActive ? `Wave ${ui.wave} in progress` : campaignComplete ? "Map secure" : `Wave ${ui.wave + 1}`}</h3>
						</div>
						{!campaignComplete && (
							<div className="wave-console__actions">
								{!ui.waveActive && <Button tone="success" onClick={actions.startWave}>Start Wave</Button>}
								<Button tone={ui.autoRun ? "danger" : "ghost"} onClick={actions.toggleAutoRun}>
									{ui.autoRun ? "Stop Auto Run" : "Auto Run"}
								</Button>
							</div>
						)}
						<div className="wave-list">
							{nextWave.map((group, index) => {
								const enemy = getEnemyDef(group.type, { mapIdx: ui.mapIdx, mapDef: currentMap, runMode: ui.runMode, waveNumber: ui.wave + 1 });
								return (
									<span key={`${group.type}-${index}`} style={{ "--tone": enemy.color }}>
										<EnemySpriteBadge type={group.type} />{enemy.name} x{group.count}
									</span>
								);
							})}
						</div>
						<p className="map-note" style={{ "--tone": currentMap.color }}>{currentMap.desc}</p>
					</div>
				)}
			</div>
		</section>
	);
}
